import { render, staticRenderFns } from "./NovaSenha.vue?vue&type=template&id=46fe941c&scoped=true&"
import script from "./NovaSenha.vue?vue&type=script&lang=js&"
export * from "./NovaSenha.vue?vue&type=script&lang=js&"
import style0 from "./NovaSenha.vue?vue&type=style&index=0&id=46fe941c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe941c",
  null
  
)

export default component.exports